import React from 'react';
import PropTypes from 'prop-types';

const HeartbingoBannerImg = ({
  bgUrl,
  textUrl,
}) => (
  <>
    { bgUrl && (
      <picture>
        <source srcSet={bgUrl.replace('default', 'webp').replace(/[^.]+$/, 'webp')} type="image/webp" />
        <img src={bgUrl} alt="banner" width="100%" className="bv-slider-item__bg" />
      </picture>
    )}
    { textUrl && (
      <picture>
        <source srcSet={textUrl.replace('default', 'webp').replace(/[^.]+$/, 'webp')} type="image/webp" />
        <img src={textUrl} alt="banner" height="100%" className="bv-slider-item__text" />
      </picture>
    )}
  </>
);

HeartbingoBannerImg.propTypes = {
  bgUrl: PropTypes.string.isRequired,
  textUrl: PropTypes.string.isRequired,
};

export default HeartbingoBannerImg;
